import { createContext } from 'react';
import defaultPropsDecorator from './defaultPropsDecorator';
export var PropsDecoratorContext = /*#__PURE__*/createContext(defaultPropsDecorator);
export default PropsDecoratorContext.Provider;